export default angular.module('sliderApp', ['ngAnimate'])
    .controller('SliderController', function (Slideshow, $scope) {
    $scope.slides = [];
    Slideshow.getSlides().then(function (data) {
        $scope.slides = data;
    });
})
    .directive('slider', function ($timeout) {
    return {
        restrict: 'C',
        link: function (scope, elem, attrs) {
            scope.currentIndex = 0;
            scope.next = function () {
                scope.currentIndex < scope.slides.length - 1 ? scope.currentIndex++ : scope.currentIndex = 0;
            };
            scope.nextSlide = function () {
                scope.currentIndex < scope.slides.length - 1 ? scope.currentIndex++ : scope.currentIndex = 0;
            };
            scope.prevSlide = function () {
                scope.currentIndex = (scope.currentIndex < scope.slides.length - 1) ? ++scope.currentIndex : 0;
            };
            scope.prev = function () {
                scope.currentIndex > 0 ? scope.currentIndex-- : scope.currentIndex = scope.slides.length - 1;
            };
            scope.setCurrentSlideIndex = function (index) {
                scope.currentIndex = index;
            };
            scope.isCurrentSlideIndex = function (index) {
                return scope.currentIndex === index;
            };
            scope.onSwipeLeft = function (ev) {
                scope.currentIndex = (scope.currentIndex < scope.slides.length - 1) ? ++scope.currentIndex : 0;
            };
            scope.onSwipeRight = function (ev) {
                scope.currentIndex = (scope.currentIndex > 0) ? --scope.currentIndex : scope.slides.length - 1;
            };
            scope.sliderRedirect = function (url) {
                window.location = url;
            };
            // console.log('currentIndex', scope.currentIndex);
            // scope.$watch('currentIndex',function(){
            //     scope.slides.forEach(function(slide){
            //         slide.visible=false;
            //     });
            //     scope.slides[scope.currentIndex].visible=true;
            // });
            /* Start: For Automatic slideshow*/
            var timer;
            var sliderFunc = function () {
                timer = $timeout(function () {
                    scope.nextSlide();
                    timer = $timeout(sliderFunc, 5000);
                }, 5000);
            };
            sliderFunc();
            scope.$on('$destroy', function () {
                $timeout.cancel(timer);
            });
            /* End : For Automatic slideshow*/
        }
    };
})
    .name;
//# sourceMappingURL=slider.js.map